import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './webfonts/ss-pika.css';
import './styles.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Logger from './shared/logger';

Logger.enabled = !!process.env.ENABLE_LOGGER;

ReactDOM.render(<App />, document.getElementById('app-container'));
